import { z } from "zod";

export const BaseCheckpointTaskSchema = z.object({
  type: z.string(),
  approved: z.boolean().optional(),
});
export type BaseCheckpointTask = z.infer<typeof BaseCheckpointTaskSchema>;

export const AiImageTaskSchema = BaseCheckpointTaskSchema.extend({
  type: z.literal("image"),
  prompt: z.string(),
  ratio: z.enum(["1:1", "16:9", "9:16", "4:3", "3:4"]).catch("1:1"),
});
export type AiImageTask = z.infer<typeof AiImageTaskSchema>;

export const AiVideoTaskSchema = BaseCheckpointTaskSchema.extend({
  type: z.literal("video"),
  prompt: z.string(),
  ratio: z.enum(["16:9", "9:16"]).catch("16:9"),
  duration: z.enum(["4", "6", "8"]).catch("4"),
});
export type AiVideoTask = z.infer<typeof AiVideoTaskSchema>;

export const AiMusicTaskSchema = BaseCheckpointTaskSchema.extend({
  type: z.literal("music"),
  prompt: z.string(),
});
export type AiMusicTask = z.infer<typeof AiMusicTaskSchema>;

export const CheckpointTaskSchema = z.discriminatedUnion("type", [
  AiImageTaskSchema,
  AiVideoTaskSchema,
  AiMusicTaskSchema,
]);
export type CheckpointTask = z.infer<typeof CheckpointTaskSchema>;
